import { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  FaUsers, FaCalendarAlt, FaFileUpload, FaClipboardList, FaFileAlt, FaLayerGroup, FaCalendarCheck, FaGlobeAmericas, FaBookOpen, FaHandshake, FaHistory, FaCampground,
} from "react-icons/fa";

// Los módulos llegan como árbol (módulo -> submodulos), hay que buscar recursivamente.
function tieneModulo(modulos, idModulo) {
  return modulos.some(
    (m) => m.id_modulo === idModulo || (m.submodulos?.length && tieneModulo(m.submodulos, idModulo))
  );
}

const SECCIONES = [
  { idModulo: 20, ruta: "usuarios", nombre: "Usuarios", descripcion: "Cuentas de acceso y permisos por módulo", icono: FaUsers },
  { idModulo: 21, ruta: "eventos", nombre: "Eventos", descripcion: "Próximos eventos visibles en el Dashboard", icono: FaCalendarAlt },
  { idModulo: 26, ruta: "programa-mensual", nombre: "Programa Mensual", descripcion: "Director, maestro, predicador, proyección, aseo y fechas especiales por servicio", icono: FaCalendarCheck },
  { idModulo: 28, ruta: "misioneros", nombre: "Misioneros", descripcion: "Misioneros activos: foto, lugar de llamado, país, título y apoyo mensual", icono: FaGlobeAmericas },
  { idModulo: 22, ruta: "manuales", nombre: "Carga Manuales", descripcion: "Manuales en PDF por módulo del sistema", icono: FaFileUpload },
  { idModulo: 23, ruta: "encuestas", nombre: "Encuestas", descripcion: "Creación y clonado de encuestas", icono: FaClipboardList },
  { idModulo: 24, ruta: "documentos", nombre: "Documentos Oficiales", descripcion: "Documentos PDF de la iglesia", icono: FaFileAlt },
  { idModulo: 25, ruta: "catalogos", nombre: "Catálogos", descripcion: "Servicios, clubs, estados y más", icono: FaLayerGroup },
  { idModulo: 29, ruta: "clases", nombre: "Clases", descripcion: "Registro por fecha de las clases de Escuela Dominical: Niños, Segundo Tiempo y Adultos", icono: FaBookOpen },
  { idModulo: 30, ruta: "reportes", nombre: "Resultados de Encuesta", descripcion: "Resultados de la encuesta por sección y miembro, para toma de decisiones", icono: FaClipboardList },
  { idModulo: 31, ruta: "reuniones", nombre: "Reuniones", descripcion: "Reuniones, bautismos, aceptación de miembros, reuniones extraordinarias y de negocio", icono: FaHandshake },
  { idModulo: 32, ruta: "historial", nombre: "Historial de cambios", descripcion: "Quién creó, modificó o desactivó información en Tesorería, Miembros, Reuniones y Usuarios", icono: FaHistory },
  { idModulo: 33, ruta: "campamentos", nombre: "Campamentos", descripcion: "Campamentos con asistentes, becas y abonos, y el reporte de lo recaudado y pendiente", icono: FaCampground },
];

export default function Administracion() {
  const { modulos } = useContext(AuthContext);

  const secciones = useMemo(
    () => SECCIONES.filter((s) => tieneModulo(modulos, s.idModulo)),
    [modulos]
  );

  return (
    <div className="p-6 bg-slate-50">

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Administración</h1>
        <p className="text-sm text-slate-500">Selecciona una sección para administrar.</p>
      </div>

      {secciones.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-10 text-center text-sm text-slate-400">
          No tienes acceso a ninguna sección de administración por el momento.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {secciones.map((s) => {
            const Icono = s.icono;
            return (
              <Link
                key={s.idModulo}
                to={`/dashboard/administracion/${s.ruta}`}
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-md transition group"
              >
                <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center mb-3 group-hover:bg-indigo-600 group-hover:text-white transition">
                  <Icono />
                </div>
                <p className="font-semibold text-sm text-slate-800">{s.nombre}</p>
                <p className="text-xs text-slate-400 mt-0.5">{s.descripcion}</p>
              </Link>
            );
          })}
        </div>
      )}

    </div>
  );
}
